export default "__VITE_ASSET__5f8bcfb4__"